// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","240":"c4669b9b","455":"9b4bab32","488":"18ef4f15","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};